import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column, VideoModal } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { initDataLayer } from '../../utilities/functions';
import styles from './index.module.scss';
import { isValidArray } from '../../utilities/validations';

const PerformancePanel = ({ data, className }) => {
	const [modalOpen, setModalOpen] = useState(false);

	if (!data) return null;

	return (
		<div
			id={data.anchor || null}
			className={`${styles.performancePackages} ${className || ''}`}
		>
			<Container>
				{data.heading && <h2 className={`${styles.performancePackages_Title} s2-h2__alt`}>{data.heading}</h2>}

				{data.subheading && (
					<div
						className={styles.performancePackages_Intro}
						dangerouslySetInnerHTML={{ __html: data.subheading }}
					/>
				)}

				{isValidArray(data?.package_types) && (
					<Row
						align='center'
						className={styles.performancePackages_Row}
					>
						<Column
							xs={12}
							sm={8}
							lg={4}
						>
							{data.package_types.map((pack, index) => {
								if (pack.position == 1 || pack.position == 2) {
									return (
										<div
											key={index}
											className={styles.performancePackages_Feature}
										>
											{pack.package?.[0]?.image?.[0] && <Image data={pack.package[0].image[0]} />}

											<h3 className={styles.performancePackages_FeatureTitle}>{pack.package[0].heading}</h3>
											<div
												dangerouslySetInnerHTML={{
													__html: pack.package[0].description,
												}}
											/>
										</div>
									);
								}
							})}
						</Column>

						<Column
							xs={12}
							lg={3}
							className={styles.performancePackages_ImageCol}
						>
							{data.main_image?.[0] && (
								<Image
									data={data.main_image[0]}
									className={styles.performancePackages_MainImage}
								/>
							)}
						</Column>

						<Column
							xs={12}
							sm={8}
							lg={4}
						>
							{data.package_types.map((pack, index) => {
								if (pack.position == 3 || pack.position == 4) {
									return (
										<div
											key={index}
											className={styles.performancePackages_Feature}
										>
											{pack.package?.[0]?.image?.[0] && <Image data={pack.package[0].image[0]} />}

											<h3 className={styles.performancePackages_FeatureTitle}>{pack.package[0].heading}</h3>
											<div
												dangerouslySetInnerHTML={{
													__html: pack.package[0].description,
												}}
											/>
										</div>
									);
								}
							})}
						</Column>
					</Row>
				)}

				{isValidArray(data?.ctas) && (
					<div className={styles.performancePackages_ButtonWrapper}>
						<CTA data={data.ctas[0]} />
					</div>
				)}

				{isValidArray(data?.video?.cta) && (
					<div className={styles.performancePackages_VideoButtonWrapper}>
						<CTA
							data={data.video.cta[0]}
							onClick={() => {
								setModalOpen(true);
								initDataLayer('videoplay');
							}}
							className={styles.performancePackages_VideoBtn}
						/>
					</div>
				)}

				{isValidArray(data?.video?.video) && (
					<VideoModal
						isOpen={modalOpen}
						onClose={() => setModalOpen()}
						videoId={data.video.video[0].video.video_id}
						title={data.video.video[0].video.title}
						transcript={data.video.video[0].transcript}
					/>
				)}
			</Container>
		</div>
	);
};

PerformancePanel.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default React.memo(PerformancePanel);
